import { render, staticRenderFns } from "./icons.vue?vue&type=template&id=f60f88f6"
import script from "./icons.vue?vue&type=script&lang=js"
export * from "./icons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f60f88f6')) {
      api.createRecord('f60f88f6', component.options)
    } else {
      api.reload('f60f88f6', component.options)
    }
    module.hot.accept("./icons.vue?vue&type=template&id=f60f88f6", function () {
      api.rerender('f60f88f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/icons.vue"
export default component.exports